import { useState } from 'react';

export default function PromptBlock({ prompt, onDelete, onSelect }) {
  const [expanded, setExpanded] = useState(false);
  const preview = prompt.content.length > 60
    ? prompt.content.slice(0, 60) + '…'
    : prompt.content;

  return (
    <div className="prompt-block">
      <div className="prompt-header">
        <span
          className="prompt-text prompt-text-clickable"
          title="Click to use in chat"
          onClick={() => onSelect(prompt.content)}
        >
          {expanded ? prompt.content : preview}
        </span>
        <div className="prompt-controls">
          <button
            className={`prompt-expand ${expanded ? 'expanded' : ''}`}
            aria-label="Toggle"
            onClick={() => setExpanded(e => !e)}
          >
            <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
              <polyline points="6 9 12 15 18 9" />
            </svg>
          </button>
          <button
            title="Delete prompt"
            onClick={e => { e.stopPropagation(); onDelete(prompt.id); }}
            className="prompt-delete"
          >
            <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
              <line x1="18" y1="6" x2="6" y2="18" /><line x1="6" y1="6" x2="18" y2="18" />
            </svg>
          </button>
        </div>
      </div>
    </div>
  );
}
